import React from "react";
import { RxCross2 } from "react-icons/rx";

const Chip = ({ label, onRemove, onClick }) => {
  return (
    <div
      onClick={() => onClick(label)}
      className={`flex  items-center gap-2 bg-blue-100 text-blue-500 px-3 py-1 rounded-full text-[12px] font-medium cursor-pointer hover:bg-blue-50`}
    >
      <span>{label}</span>
      {onRemove && (
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove(label);
          }}
          className="w-5 h-5 flex items-center justify-center "
        >
          <RxCross2 className=" text-blue-500 text-sm rounded-full " />
        </button>
      )}
    </div>
  );
};

export default Chip;
